import React from 'react';
import { getCircuitTypeDisplayLabel } from '@src/utils/enums';
import './connection-type.scss';

export const ConnectionType: React.FC<{circuitType?: string}> = ({ circuitType }) => {
    return <div className="connection-type"><span>{getCircuitTypeDisplayLabel(circuitType)}</span></div>;
};